export const outerPadding = '1rem 10rem'
